import { render, staticRenderFns } from "./ContactSupportForm.vue?vue&type=template&id=54e9607c&scoped=true&"
import script from "./ContactSupportForm.vue?vue&type=script&lang=js&"
export * from "./ContactSupportForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactSupportForm.vue?vue&type=style&index=0&id=54e9607c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9607c",
  null
  
)

export default component.exports